<template>
  <div>
    <div class="show-form-cars">
      <table class="table">
        <tbody>
        <tr>
          <td class="label-col">Марка</td>
          <td><input type="text" class="form-control form-control-sm" v-model="car.brand" placeholder required></td>
        </tr>
        <tr>
          <td>Модель</td>
          <td><input type="text" class="form-control form-control-sm" v-model="car.model" placeholder required></td>
        </tr>
        <tr>
          <td>Рег. номер</td>
          <td><input type="text" class="form-control form-control-sm" v-model="car.registration_plate" placeholder required></td>
        </tr>
        <tr>
          <td>Год выпуска</td>
          <td><input type="text" class="form-control form-control-sm" v-model="car.manufacturing_year" placeholder required></td>
        </tr>
        <tr>
          <td>Код радио</td>
          <td><input type="text" class="form-control form-control-sm" v-model="car.radio_code" placeholder required></td>
        </tr>
        <tr>
          <td>Пробег</td>
          <td>
            <span>{{actualOdometer}}</span>
            <button class="btn btn-default side-button-create float-right" @click="showMileagePanel = !showMileagePanel">Задать пробег</button>
          </td>
        </tr>
        <tr>
          <td>Устройство геопозиционирования</td>
          <td>
            <div style="display: flex">
              <v-select
                style="width: 100%"
                :options="trackingDevicesList"
                v-model="car.tracking_device_id"
                :reduce="device => device.id"
                label="imei"
              >
                <template v-slot:option="option">
                  {{ option.imei }}
                  <sub>{{ option.name }}</sub>
                </template>
              </v-select>
              <button class="btn btn-default side-button-create" @click="showDevicePanel = !showDevicePanel">Добавить устройство</button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <hr class="mb-4" />
    </div>
    <transition name="fade">
      <div class="side-panel" v-if="showDevicePanel">
        <div class="side-button-close" @click="showDevicePanel = !showDevicePanel" >+</div>
        <div class="side-title">Добавить устройство:</div>
        <hr>
        <div class="row">
          <div class="col-md-6 mb-2">
            Название устройства наблюдения
            <input type="text" class="form-control" v-model="devise.trackingDevice.name" placeholder required />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-2">
            IMEI
            <input type="text" class="form-control" v-model="devise.trackingDevice.imei" placeholder required />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 mb-2">
            Тип прошивки
            <v-select
              :options="devise.firmwares"
              v-model="devise.trackingDevice.firmware_id"
              :reduce="firmware => firmware.id"
              label="name"
            />
          </div>
        </div>
        <button class="btn btn-success float-right" @click="createDocument()">Создать</button>
      </div>
    </transition>
    <transition name="fade">
      <div class="side-panel" v-if="showMileagePanel">
        <div class="side-button-close" @click="showMileagePanel = !showMileagePanel" >+</div>
        <div class="side-title">Пробег</div>
        <hr>
        <div class="row">
          <div class="col-md-6 mb-6 my-2">
            Задать текущий пробег
            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="odometerCorrection.actual_odometer" placeholder required />
              <div class="input-group-append">
                <button class="input-group-btn btn btn-success" @click="createOdometerCorrection()">Задать</button>
              </div>
            </div>
          </div>
        </div>
        <div class="row  my-2" >
          <div class="col-md-4 mb-2">
            История изменений
            <span class="d-flex justify-content-center" v-if="!odometerHistoryItems">Не найдено изменений пробега</span>
            <ul class="list-group">
              <div v-for="item in odometerHistoryItems" :key="item.mileage">
                <li class="list-group-item">
                  <div class="row mx-1">
                    <span class="text-dark font-weight-bold">{{ item.mileage }} км</span>
                  </div>
                  <div class="row mx-1">
                    {{ item.date }} {{ item.author }}
                  </div>
                </li>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import trackDevicesAPI from '@/api/track-devices'
import Swal from 'sweetalert2'
import odometerCorrectionApi from '@/api/odometercorrection'
import usersAPI from '@/api/users'
import { djsMixin } from '@/components/mixins/djsMixin'

export default {
  name: 'CarEditForm',
  props: ['id', 'car', 'trackingDevicesList'],
  mixins: [djsMixin],
  mounted () {
    trackDevicesAPI.getFirmwares().then(response => {
      this.devise.firmwares = response
    })
    odometerCorrectionApi.getActualOdometer({ id: this.car.id })
      .then(odometer => {
        this.actualOdometer = odometer
      })
    this.getHistory()
  },
  data () {
    return {
      actualOdometer: 0,
      isCreating: false,
      showDevicePanel: false,
      showMileagePanel: false,
      devise: {
        firmwares: [],
        trackingDevice: {}
      },
      odometerCorrection: {
        tracking_device_id: null,
        actual_odometer: null,
        timestamp: this.now(),
        device_odometer: 0,
        car_id: null,
        author_id: null
      },
      odometerHistoryItems: null
    }
  },
  methods: {
    getHistory () {
      odometerCorrectionApi.getHistoryOdometer({ id: this.car.id })
        .then(history => {
          if (history.length !== 0) {
            this.odometerHistoryItems = history
          } else {
            this.odometerHistoryItems = null
          }
        })
    },
    createDocument () {
      if (this.isCreating) {
        return
      }
      this.isCreating = true
      trackDevicesAPI.createItem(this.devise.trackingDevice)
        .then(trackDevice => {
          this.isCreating = false
          this.trackingDevicesList.push(trackDevice.model)
          this.showDevicePanel = false
          this.devise.trackingDevice.name = ''
          this.devise.trackingDevice.imei = ''
          this.devise.trackingDevice.firmware_id = null
          this.car.tracking_device_id = trackDevice.model.id
        })
        .catch(text => {
          this.isCreating = false
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    },
    createOdometerCorrection () {
      if (this.isCreating) {
        return
      }
      this.isCreating = true
      usersAPI
        .getCurrentUser()
        .then(user => {
          this.isCreating = true
          this.odometerCorrection.author_id = user.id
          this.odometerCorrection.car_id = this.car.id
          this.odometerCorrection.tracking_device_id = this.car.trackingDevice.id
          odometerCorrectionApi.createItem({
            ...this.odometerCorrection,
            timestamp: this.toUTCtranslate(this.odometerCorrection.timestamp)
          })
            .then(() => {
              this.isCreating = false
              this.showMileagePanel = false
              this.actualOdometer = this.odometerCorrection.actual_odometer
              this.odometerCorrection.actual_odometer = null
              this.getHistory()
            })
            .catch(text => {
              this.isCreating = false
              Swal.fire({
                icon: 'error',
                title: 'Ошибка',
                html: text.message
              })
            })
        })
        .catch(text => {
          this.isCreating = false
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    }
  }
}
</script>

<style scoped>
  .show-form-cars span {
    margin: 10px;
  }
  .show-form-cars {
    margin-top: 4rem;
  }
  .label-col {
    width: 25%;
  }
  .side-panel {
    position: fixed;
    z-index: 999999;
    top: 0;
    right: 0;
    background: #ffffff;
    transition: right 1.0s;
    width: 700px;
    max-width: 100%;
    height: 100vh;
    box-shadow: 10px 0 20px rgba(0,0,0,0.4);
    color: #616161;
    padding: 40px 20px;
  }
  .side-title {
    font-size: 20px;
  }
  .side-button-create {
    white-space: nowrap;
    margin-left: 10px;
    border-color: #adadad;
  }
  .side-button-close {
    font-size: 30px;
    border-radius: 20px;
    position: absolute;
    z-index: 1;
    top: 8px;
    right: 8px;
    cursor: pointer;
    transform: rotate(45deg);
    color: #454545;
    transition: right 280ms ease-in-out;
  }
  .side-button-close:hover {
    transform: rotate(45deg) scale(1.1);
    color: #000000;
  }
  .col-md-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .col-md-4 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .fade-enter-active, .fade-leave-active {
    transition: right .1s;
  }
  .fade-enter, .fade-leave-to {
    right: -760px;
  }
</style>
